var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "svgPath",
    d: "M26.25 32.1C26.609 32.1 26.9 31.809 26.9 31.45C26.9 31.091 26.609 30.8 26.25 30.8H17.8C16.3641 30.8 15.2 29.636 15.2 28.2V17.8C15.2 16.3641 16.3641 15.2 17.8 15.2H26.25C26.609 15.2 26.9 14.909 26.9 14.55C26.9 14.191 26.609 13.9 26.25 13.9H17.8C15.6461 13.9 13.9 15.6461 13.9 17.8V28.2C13.9 30.3539 15.6461 32.1 17.8 32.1H26.25ZM27.7404 17.9904C27.9942 17.7366 28.4058 17.7366 28.6596 17.9904L33.2096 22.5404C33.4635 22.7942 33.4635 23.2058 33.2096 23.4596L28.6596 28.0096C28.4058 28.2635 27.9942 28.2635 27.7404 28.0096C27.4866 27.7558 27.4866 27.3442 27.7404 27.0904L31.1808 23.65H19.75C19.391 23.65 19.1 23.359 19.1 23C19.1 22.641 19.391 22.35 19.75 22.35H31.1808L27.7404 18.9096C27.4866 18.6558 27.4866 18.2442 27.7404 17.9904Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.d7d3a06498388cafaccef00b4e41d9f7.svg";
export { ForwardRef as ReactComponent };